import { getStore } from '../store/store';

export default function getCountOfHiddenTopResults() {
    const { topResults, numberOfTopResultsShown } = getStore();
    const remainingTopResults = topResults?.slice(numberOfTopResultsShown);
    return remainingTopResults?.length || 0;
}
